export default __webpack_public_path__ + "static/media/4.fa5d752c.jpeg";